import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Wand2, Sparkles, Film } from "lucide-react";
import api from "@/lib/api";
import { CinematicStage, StageHeader, EmptyState, Spinner, fadeUp, stagger } from "@/components/shared";
import { ROOM_BACKDROPS } from "@/lib/studio";
import FilmCard from "@/components/FilmCard";

export default function Projects() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState(null);

  useEffect(() => { api.get("/projects").then(({ data }) => setProjects(data)).catch(() => setProjects([])); }, []);

  if (!projects) return <Spinner label="Opening the film library…" />;

  return (
    <CinematicStage>
      <StageHeader
        stage="00"
        room="The Film Library"
        icon={Film}
        title="Your Productions"
        subtitle="Every film your studio has produced — from first spark to final cut."
        actions={
          <button onClick={() => navigate("/create")} data-testid="projects-new-button" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-[#5B4DFF] text-white font-semibold glow-purple">
            <Wand2 className="w-4 h-4" /> New Film
          </button>
        }
      />
      {projects.length === 0 ? (
        <EmptyState
          image={ROOM_BACKDROPS.floor}
          icon={Sparkles}
          title="An empty stage, waiting for a story"
          subtitle="Produce your first film from a single idea and it takes its place in the library."
          action={<button onClick={() => navigate("/create")} className="px-5 py-2.5 rounded-xl bg-[#5B4DFF] text-white font-semibold">Start Producing</button>}
        />
      ) : (
        <motion.div variants={stagger} initial="hidden" animate="show" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {projects.map((p, i) => (
            <motion.div key={p.id} variants={fadeUp}>
              <FilmCard project={p} index={i} />
            </motion.div>
          ))}
        </motion.div>
      )}
    </CinematicStage>
  );
}
